import { render } from "./ClientServicesStats.vue?vue&type=template&id=365d7045"
import script from "./ClientServicesStats.vue?vue&type=script&lang=js"
export * from "./ClientServicesStats.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__